import { DEFAULT_VIDEO_THUMBNAIL } from './default_video_thumbnail'

const VIDEO_PLACEHOLDER_THUMBNAIL = DEFAULT_VIDEO_THUMBNAIL

interface VideoThumbnailResult {
  uri: string | null
  width?: number
  height?: number
}

export const generateThumbnail = async (): Promise<VideoThumbnailResult> => {
  return {
    uri: VIDEO_PLACEHOLDER_THUMBNAIL,
    width: 100,
    height: 100,
  }
}
